import tripettoFonts from '../style/tripetto/fonts.css';
import tripettoCustomCss from '../style/tripetto/main.css';
// import { analytics } from '../analytics';

const params = new URLSearchParams(window.location.search)
const tunnelName = params.get('name') || 'tunnel-public'
const tunnelVersion = params.get('version') || 'master'
const gclid = params.get('gclid')
const partner = params.get('partner')


/* display partner logo*/
const element = document.querySelector('.'+partner);
if(element){
  element.classList.remove("hidden");
  document.querySelector('#cross-by').classList.remove("hidden");
}


const styles = {
  "direction": "horizontal",
  "verticalAlignment": window.innerWidth > 768 ? "top" : "top",
  "hidePast": true,
  "hideUpcoming": true,
  "showNavigation": "always",
  "showProgressbar": true,
  "showEnumerators": false,
  "autoFocus": true,
  "showSeparateSubmit": false,
  "showPreviousButton": true,
  "showScrollbar": false,
  "noBranding": true,
  "contract": {
    "name": "tripetto-runner-autoscroll",
    "version": "3.9.5"
  },
  "font": {
    "size": 16,
    "family": "Source Sans Pro"
  },
  "color": "black",
  "buttons": {
    "mode": "fill",
    "roundness": 4,
    "baseColor": "#ff0063",
    "textColor": "white"
  },
  "inputs": {
    "borderSize": 1,
    "roundness": 4,
    "selectionColor": "#ff0063",
    "baseColor": "#ff0063",
    "textColor": "#363636"
  },
  "navigation": {
    "progressbarColor": "#db0a40"
  }
};


const l10n = {
  "locale": "fr",
  "contract": {
    "name": "tripetto-runner-autoscroll",
    "version": "3.9.5"
  },
  "translations": {
    "": {
      "language": "fr"
    },
    "runner#1|🆗 Buttons\u0004Back": [
      null,
      "Précédent"
    ],
    "runner#1|🆗 Buttons\u0004Next": [
      null,
      "Suivant"
    ],
    "runner#1|🆗 Buttons\u0004Retry": [
      null,
      "Réessayer"
    ],
    "runner#1|🆗 Buttons\u0004Discard": [
      null,
      "Ignore"
    ],
    "runner#1|🆗 Buttons\u0004Reload": [
      null,
      "Recharger"
    ],
    "runner#1|🆗 Buttons\u0004Start": [
      null,
      "Commencer"
    ],
    "runner#1|🆗 Buttons\u0004Start again": [
      null,
      "Recommencer"
    ],
    "runner#1|🆗 Buttons\u0004Submit": [
      null,
      "Suivant"
    ],
    "runner#3|🩺 Status information\u0004%1 of %2 answered": [
      null,
      "%1/%2"
    ],
    "runner#9|⚠ Errors|Input error\u0004%1 item requires your attention! Click to fix.": [
      null,
      "%1 élément nécessite votre attention! Cliquez pour le corriger."
    ]
  }
};


const customCSS = atob(tripettoFonts.split(',')[1]) + atob(tripettoCustomCss.split(',')[1]);

const getLastUpdatedStep = (data) => {
  return data.fields.reduce((previousValue, currentValue) => {
    if (previousValue) {
      if (currentValue) {
        if (currentValue.time > previousValue.time) {
          return currentValue;
        } else {
          return previousValue;
        }
      } else {
        return previousValue;
      }
    } else {
      return currentValue;
    }
  });
};

const trackTripettoPageView = (path) => {
  // we provide a custom document location URL to force the tracking
  // for a specific fake path
  // const documentLocationUrl = window.location.origin + '/' + tunnelVersion + '/' + tunnelName + path;
  // analytics.trackPageView({ documentLocationUrl });
  /*if (window.ga) {
    window.ga('set', 'page', path);
    window.ga('send', 'pageview');
  }*/
  dataLayer.push({
    'event': 'tripetto-page-view',
    'page':{
      'url': path
    }
  });
};


const getTunnelDefinition = async () => {
  const res = await fetch(`data/${tunnelVersion}/${tunnelName}.json`)

  if (res.ok) {
    const { definition } = await res.json()
    return definition
  } else {
    return {}
  }
}

const definition = getTunnelDefinition();

export {
  styles,
  l10n,
  customCSS,
  definition,
  getLastUpdatedStep,
  trackTripettoPageView,
  tunnelName,
  tunnelVersion,
  gclid
}
